import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap'
import AccountMenu from '../../Modules/AccountMenu'
import OnbekendeCursus from '../../Modules/Kennis/Toevoegen/OnbekendeCursus';

class MemberCursusAdd extends Component {
	render() {
		return (
			<div className="route">
				<AccountMenu />
				<div className="grey-bg">
					<h1 className="pageTitle">
						Een incompany cursus toevoegen
            </h1>
					<Row>
						<Col md={12}>
							<OnbekendeCursus />
						</Col>
					</Row>
					{/* <Bijeenkomst /> */}
				</div>
			</div>
		);
	}
}

export default MemberCursusAdd;



// WEBPACK FOOTER //
// ./src/components/Member/Pages/Toevoegen/IncompanyCursus.js